import { Component, Input, AfterViewInit, Injector } from '@angular/core';
import { SummaryService } from '../../../../services/summary.service';
import { StepService } from '../../services/step.service';
import { Observable, firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { UnidadDetailModalComponent } from '../unidad-detail-modal/unidad-detail-modal.component';
import { AvailableCar } from '../../interfaces/ICarsAvailable';
import { CatalogsService } from '../../../../services/catalogs.service';
import { ModalService } from '../../../../services/modal-service.service';
import { Icons } from '../../../../components/modal-alert/enums';
import { CarManagerService } from '../../../../services/car-manager.service';
import { ISelectedCar } from '../../interfaces/ISearchCar';
import { BuroService } from '../../../../services/buro.service';
import { ICotizacionData } from '../../interfaces/journey.model';
import { CotizadorService } from '../../../../services/cotizador.service';
import { DataService } from '../../../../services/data.service';
import { Endpoints } from 'src/environments/endpoints';
import {
  SseService,
  SseEvent,
  SseEventType,
} from '../../../../services/sse.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unidad-detail-options',
  templateUrl: './unidad-detail-options.component.html',
  styleUrls: ['./unidad-detail-options.component.scss'],
})
export class UnidadDetailOptionsComponent implements AfterViewInit {
  @Input()
  car!: AvailableCar;
  @Input() option!: number;

  idCard = 0;

  isRecalculated = false;
  summary: any = {
    idCar: null,
    carTitle: '---',
    carModel: '---',
    carImage: './assets/img/auto_no_disponible.svg',
    state: '---',
    priceWithIva: '0',
    refund: '0',
    concept: '---',
    period: '---',
    initialPayment: '0',
    monthlyPayment: '0',
    insurance: '---',
    additionalCost: 0,
    comment: null
  };
  isBlocked = false;

  showDetails = true;
  showDetailsCost = false;

  isMove = false;
  // isFlowA = true;
  detailsArr = [
    {
      desc: 'Color interior',
      value: 'Negro',
    },
    {
      desc: 'Color exterior',
      value: 'Rojo',
    },
    {
      desc: 'Transmisión',
      value: 'Manual',
    },
    {
      desc: 'Tipo de combustible',
      value: 'Premium',
    },
  ];

  dateFinished: any = null;

  formatter = new Intl.NumberFormat('es-MX');

  stepService!: StepService;
  dialog!: MatDialog;
  catalogService!: CatalogsService;
  managerService!: CarManagerService;
  modalService!: ModalService;
  sseService: SseService;

  templateSuffix = environment.templateSuffix;

  constructor(
    private dataService: DataService,
    private summaryService: SummaryService,
    private buroService: BuroService,
    private cotizadorService: CotizadorService,
    private injector: Injector
  ) {
    this.stepService = this.injector.get<StepService>(StepService);
    this.dialog = this.injector.get<MatDialog>(MatDialog);
    this.catalogService = this.injector.get<CatalogsService>(CatalogsService);
    this.managerService =
      this.injector.get<CarManagerService>(CarManagerService);
    this.modalService = this.injector.get<ModalService>(ModalService);
    this.sseService = this.injector.get<SseService>(SseService);

    // this.isFlowA = this.stepService.isFlow('A');
  }

  ngAfterViewInit(): void {
    this.summary.idCar = this.car.leaseTechId;

    this.catalogService.getQuoteCarById(this.summary.idCar).subscribe({
      next: (resp) => this.validateRespImages(resp),
      error: () =>
        this.showAlertError(
          'Ha ocurrido un error al obtener la imagen del auto'
        ),
    });
  }

  validateRespImages(resp: any) {
    this.summary.carTitle = `${this.car.brand} ${this.car.subBrand}`;
    this.summary.carModel = `${this.car.version} ${this.car.year}`;
    this.summary.carImage = this.summaryService.imgCarCard(
      resp.data.hits.hits[0]._source
    );
    this.summary.state = this.car.stateName;
    this.summary.refund = this.car.advancedRent;
    this.summary.concept = this.car.product;
    this.summary.period = this.car.period;
    this.summary.initialPayment = this.car.initialPayment;
    this.summary.monthlyPayment = this.car.monthlyPayment;
    this.summary.insurance = this.car.insurance;
    this.summary.additionalCost = +this.car.aditionalCost!;
    this.summary.comment = this.splitComent(this.car.comment);
    this.detailsArr[0].value = this.car.colorInt!;
    this.detailsArr[1].value = this.car.colorExt!;
    this.detailsArr[2].value = this.car.transmission!;
    this.detailsArr[3].value = this.car.powerTrain!;

    this.dateFinished = this.car.expirationDate;

    this.idCard = this.car.id!;
  }

  changeCar(option: number) {
    const modal = this.dialog
      .open(UnidadDetailModalComponent, {
        data: {
          summary: this.summary,
          details: this.detailsArr,
          option,
        },
      })
      .afterClosed();

    this.checkResp(modal);
  }

  checkResp(modal: Observable<any>) {
    modal.subscribe((resp) => {
      if (resp) {
        const body: ISelectedCar = {
          idKeycloak: this.stepService.data.idKeycloak!,
          quoterId: this.car.idQuoter!,
          ticketSearch: this.stepService.data.E22.ticketbusqueda,
          acceptShippingCost: this.isMove,
        };

        this.stepService.loadingCarSelected.next(true);

        this.managerService.sendCarSelected(body).subscribe({
          next: () => {
            // if (this.stepService.isFlow('A')) { //TODO: flowb
              this.showAlertSuccess(
                `Se ha enviado el auto ${this.summary.carTitle} ${this.summary.carModel} como tu elección`
              );
              this.stepService.data.step = 'E28';
              this.stepService.data.status = 'En proceso';
              this.stepService.state.next('E28');
            /* } else {
              this.listen();
            } */
            this.refreshInfo();
          },
          error: (err) => {
            const { error } = err;
            this.stepService.loadingCarSelected.next(false);
            if (error.userError === 'El precio del auto tuvo un cambio') {
              this.stepService.isPriceChanged.next(true);
              this.refreshInfo();
            }
          },
        });
      }
    });
  }

  /* listen() {
    this.dataService.setIsBlockedForContracts(true);
    const url = `${Endpoints.sse.base}/subscribe/${this.stepService.data.id}`;

    this.sseService.getServerSentEvent(url).subscribe({
      next: (event: SseEvent) => this.validateRespSse(event),
    });
  } */ //TODO: flowb

  validateRespSse(event: SseEvent) {
    switch (event.type) {
      case SseEventType.connectionUp:
        break;
      case SseEventType.data:
        this.sseService.destroy();
        this.dataService.setIsBlockedForContracts(false);
        this.stepService.data.step = 'E29';
        this.stepService.data.status = 'En proceso';
        this.stepService.state.next('E29');
        break;
      case SseEventType.connectionDown:
        break;
      default:
        break;
    }
  }

  changeCost(event: any) {
    this.isMove = event.checked;

    const initialPayment = +this.summary.initialPayment;
    const aditionalCost = this.summary.additionalCost;

    const sum = event.checked ? aditionalCost : -1 * aditionalCost;
    this.summary.initialPayment = initialPayment + sum;
  }

  getColor() {
    return { color: this.isMove ? '#4106ff' : '' };
  }

  refreshInfo() {
    this.buroService.getStateUser(this.stepService.data.idKeycloak!).subscribe({
      next: (resp: any) => this.validateRespUser(resp.data),
      error: () =>
        this.showAlertError(
          'Ha ocurrido un error al actualizar la información'
        ),
    });
  }

  validateRespUser(data: ICotizacionData) {
    this.stepService.data = { ...this.stepService.data, ...data };
    this.setCard();
  }

  async setCard() {
    const quoterId = this.stepService.data.quoterId!;
    const { concept, period } = this.stepService.data.product;
    const resp: any = await firstValueFrom(
      this.cotizadorService.getParamsQuote(
        quoterId,
        concept.toLowerCase(),
        period
      )
    );

    if (resp.request !== null) {
      await this.summaryService.getInfoSummary(resp);
    } else {
      this.showAlertError('Ha ocurrido un error al actualizar la información');
    }
  }

  // ALERTS

  showAlertError(msg: string) {
    this.stepService.loadingCarSelected.next(false);
    this.modalService.openAlert(
      {
        title: '',
        content: msg,
        btnAction1: 'Entendido',
        btnAction2: '',
        icon: Icons.error,
        idBtnAction1: null,
        idBtnAction2: null,
      },
      true
    );
  }

  showAlertSuccess(msg: string) {
    this.modalService.openAlert(
      {
        title: '',
        content: msg,
        btnAction1: 'Entendido',
        btnAction2: '',
        icon: Icons.success,
        idBtnAction1: null,
        idBtnAction2: null,
      },
      true
    );
  }

  splitComent(coment?:string) {
    if(coment == null || coment === '') {
      return null;
    }
    if(coment.length > 150) {
      return `${coment.slice(0,147)}...`;
    }
    return coment;
  }

}
